<div class="container products deal">
  <div class="heading heading-flex heading-border mb-3" contentAnim aniName="blurIn">
    <div class="heading-left">
      <h2 class="title">New Products</h2>
    </div>
    <!-- **************** Heading right not needed ***********************************
    <div class="heading-right">
      <ul class="nav nav-pills nav-border-anim justify-content-center" role="tablist" tabClick>
        <li class="nav-item" *ngFor="let cat of cats; let index = index">
          <a class="nav-link" [class.active]="index === 0" href="" role="tab"
          (click)="nav.select( 'deal-' + cat )">{{ titles[cat] }}</a>
        </li>
      </ul>
    </div>
    -->
  </div>

  <ul ngbNav #nav="ngbNav" class="tab-content tab-content-carousel" [destroyOnHide]="false" >
    @for (cat of cats; track cat; let index = $index) {
      <li [ngbNavItem]="'deal-' + cat" ><!--*ngFor="let cat of cats; let index = index"> -->
        <ng-template ngbNavContent>
          @if (!loaded) {
            <owl-carousel-o carouselClasses="owl-simple carousel-equal-height carousel-with-shadow"
              [options]="customOptions">
              <!--
              <ng-template carouselSlide [id]="index.toString()">
                <div class="skel-pro" *ngFor="let i of products.length.toString()"></div>
              </ng-template>
              -->
              @for (i of [1,2,3,4,5,6]; track i; let skeletonIndex = $index) {
                <ng-template carouselSlide [id]="'skeleton-' + index + '-' + skeletonIndex">
                  <div class="skel-pro"></div>
                </ng-template>
              }
            </owl-carousel-o>
          } @else {
            <owl-carousel-o carouselClasses="owl-simple carousel-equal-height carousel-with-shadow" [options]="customOptions" >
              @for (product of products; track product; let productIndex = $index) {
                <ng-template carouselSlide [id]="index + '-' + productIndex" class="owl-simple carousel-equal-height carousel-with-shadow" >
                  <molla-product-twelve [product]="product" > <!-- | catFilter : [cat] | slice: 0: 6"> -->
                  </molla-product-twelve>
                </ng-template>
              }
            </owl-carousel-o>
          }
        </ng-template>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
